<script>
	import { onMount } from 'svelte';
	// import Cite from 'citation-js';
	import { Cite } from '@citation-js/core';
	import * as pluginCSL from '@citation-js/plugin-csl';
	import * as pluginBibtex from '@citation-js/plugin-bibtex';
	import * as pluginRIS from '@citation-js/plugin-ris';

	/**
	 * @type {Object} articleData
	 */
	export let articleData;

	let formats = ['apa', 'vancouver', 'harvard1'];
	let selectedFormat = formats[0];
	let citationResult = '';

	// Function to transform articleData to a format suitable for citation-js
	/**
	 * @param {Object} article
	 */
	function transformDataToCitation(article) {
		return {
			id: article.id,
			title: article.title,
			author:
				article.authors && article.authors.length > 0
					? article.authors.map((author) => ({
							given: author.first_name,
							family: author.last_name
							// Additional fields like affiliation could be added here if needed
						}))
					: [],
			issued: {
				'date-parts': [
					[
						parseInt(article.date_published.split('-')[0]),
						parseInt(article.date_published.split('-')[1]),
						parseInt(article.date_published.split('-')[2])
					]
				]
			},
			'container-title': 'International Conference on Dublin Core and Metadata Applications',
			DOI: article.doi,
			type: 'article-journal',
			language: 'en',
			source: 'Dublin Core Metadata Initiative',
			volume: article.volume || article.year,
			issue: article.issue || '1'
			// Add more fields as necessary
		};
	}

	async function generateCitationOld() {
		try {
			const transformedData = transformDataToCitation(articleData);
			const cite = new Cite(transformedData);
			const output = await cite.format('bibliography', {
				format: 'html',
				template: selectedFormat.toLocaleLowerCase(),
				lang: 'en-US'
			});
			citationResult = output;
		} catch (error) {
			console.error('Error generating citation:', error);
			citationResult = 'Error generating citation';
		}
	}
	/**
	 * @param {String} selectedFormat
	 */
	async function generateCitation(selectedFormat) {
		try {
			const transformedData = transformDataToCitation(articleData);
			const citation = new Cite(transformedData);
			// if selectedFormat is in the list of formats then do the below
			if (formats.includes(selectedFormat)) {
				// Generate the citation in the selected format
				const output = citation.format('bibliography', {
					format: 'html',
					template: selectedFormat.toLocaleLowerCase(),
					lang: 'en-US'
				});
				citationResult = output;
			}
			if (selectedFormat === 'bibtex') {
				// Generate the citation in LaTeX format
				const output = citation.format('bibtex');
				// Wrap the BibTeX citation in a pre tag to preserve the line breaks
				citationResult = `<pre class="text-xs">${output}</pre>`;
			}
			if (selectedFormat === 'ris') {
				// Generate the citation in RIS format
				const output = citation.format('ris');
				// Wrap the RIS citation in a pre tag to preserve the line breaks
				citationResult = `<pre class="text-xs">${output}</pre>`;
			}
			if (selectedFormat === '') {
				// Generate the citation in the default format
				const output = citation.format('bibliography', {
					format: 'html',
					template: 'apa',
					lang: 'en-US'
				});
				citationResult = output;
			}
		} catch (error) {
			console.error('Error generating citation:', error);
			citationResult = 'Error generating citation';
		}
	}
	onMount(() => {
		generateCitation(selectedFormat);
	});
	$: selectedFormat !== '' && generateCitation(selectedFormat);
</script>

<div class="container flex gap-4">
	<div class="xl:w-1/5">
		<label for="format-select" class="block text-xs font-medium text-gray-600"
			>Select Citation Style</label
		>
		<select
			id="format-select"
			bind:value={selectedFormat}
			class="mt-2 block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-blue-600 sm:text-sm sm:leading-6"
		>
			<option value="apa">APA</option>
			<option value="vancouver">Vancouver</option>
			<option value="harvard1">Harvard</option>
			<option value="bibtex">LaTeX (BibTeX)</option>
			<option value="ris">RIS</option>
		</select>
	</div>

	<div class="w-2/3">
		<div class="p-4 overflow-auto bg-white">
			{@html citationResult}
		</div>
	</div>
</div>
